import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { Button, Menu, MenuItem } from '@material-ui/core';

export function DropDownFilter({ setFilter, filter, options }) {
  const cleanOptions = new Set(options?.map(JSON.stringify));
  const displayOptions = Array.from(cleanOptions).map(JSON.parse);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (e) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [e.target.name]: !prevFilter[e.target.name],
    }));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        style={{
          width: 'max-content',
          marginLeft: '-10px',
          textTransform: 'none',
          color: 'var(--table-color-title)',
          fontWeight: 600,
          fontFamily: 'Raleway',
          fontSize: '14px',
          backgroundColor: 'transparent',
        }}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        Resultado do processamento <FontAwesomeIcon icon={faAngleDown} />
      </Button>
      <Menu
        elevation={0}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        id="simple-menu"
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {displayOptions?.map((el, index) => (
          <MenuItem style={{ width: '300px', overflowX: 'hidden' }}>
            <div
              className="br-checkbox"
              style={{ position: 'relative', top: '4px' }}
            >
              <input
                id={el.display}
                name={el.display}
                type="checkbox"
                checked={filter?.[`${el.display}`] || false}
                onClick={handleChange}
              />
              <label htmlFor={el.display}>{el.display}</label>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

DropDownFilter.propTypes = {
  setFilter: PropTypes.func.isRequired,
  filter: PropTypes.any,
};

DropDownFilter.defaultProps = {
  filter: '',
};
